import { ChartType } from '../../../../pages/Summary/Components/Charts/ChartTypes.ts';
import GraphViewControlBar from '../GraphViewControlBar.tsx';

/**
 * AssetCategoryType - Component for rendering the GraphViewControlBar
 * with empty arguments for Asset Category view
 */
const AssetByEndOfLeaseType = () => {
  return (
    <GraphViewControlBar chartType={ChartType.ASSET_END_DATE} viewAll />
  );
};

export default AssetByEndOfLeaseType;
